import env from '@/env'
import axios from 'axios'
import i18n from '@/i18n'

const headers = {
  'X-AGILE-CLIENT': 'html_app',
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  Accept: 'application/json, text/plain, */*',
}

let instance = axios.create({
  baseURL: env.contextPath(),
  headers
})

const instanceApi = axios.create({
  baseURL: env.apiV1Path(),
  headers: { 'X-AGILE-CLIENT': 'html_app' },
  withCredentials: true,
})

export default {
  instance,
  instanceApi,

  searchClientConfig: () => {
    return instance
    .post('/sistema/configsistema/crud!getConfigAgilePromoterDTO.action', null, { withCredentials: true })
    .then(response => response.data)
    .catch((error) => {
      if (error.response.status === 404) return Promise.reject(new Error('Client config doesnt exists'))
      return Promise.reject(new Error(error))
    })
  },

  authenticate: ({ username, password }) => {
    const data = new URLSearchParams();
    data.append('j_username', username);
    data.append('j_password', password);

    return instance
      .post('/j_spring_security_check', data, { withCredentials: true })
      .then(response => {
          return response.data
      })
      .then((response) => {
        if (response.responseCode === 403) return Promise.reject(response)
        return response
      })
      .catch(error => {
        const errorMessage = error.keyMessage ? i18n.t(error.keyMessage) : error.mensagem;
        return Promise.reject(new Error(errorMessage))
      })
  },

  requestPassword: (email) => {
    const data = new URLSearchParams();
    data.append('email', email);

    return instance
      .post('/sistema/recuperarsenha.action', data, { withCredentials: true })
      .then(response => response.data)
      .then((response) => {
        if (response.actionErrors) return Promise.reject(response.actionErrors[0])
        return response
      })
      .catch(error => Promise.reject(new Error(error)))
  },

  resetPassword: (password, token) => {
    return instanceApi
      .put(`/password/${token}`, {
        id: token,
        password,
        confirmPassword: password,
      })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data))
  },

  verifyToken: (token) => {
    return instanceApi
      .get(`/password/recovery/${token}`)
      .then(response => response.data)
      .catch(error => Promise.reject(new Error(error.response.data.message)))
  },

  isAuthenticated: () => {
    return instance
      .post('/seguranca/retrieveLoggedUser.action', null, { withCredentials: true })
      .then(response => response.data)
      .then((response) => {
        if (response.responseCode !== 200) return Promise.reject('user isnt authenticated')
        return response
      })
      .catch(error => Promise.reject(new Error(error)))
  },

  getBannerJson: (bannerUrl)=> {
    const messageError = 'banner not found'
    if (!bannerUrl || bannerUrl.length === 0) {
      return Promise.reject(new Error(messageError))
    }
    return axios
      .get(bannerUrl)
      .then((response) => {
        if (response.status !== 200) return Promise.reject(messageError)
        return response
      })
      .catch(error => Promise.reject(error))
  }
}
